import Vue from "vue";

export default Vue.extend({
  computed: {
    isPreview(): boolean {
      return this.$router.currentRoute.name === 'dashboardPreview';
    },
  },
});